import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
export function SearchIcon() {
    return _jsx(FontAwesomeIcon, { icon: faMagnifyingGlass });
}
